<template>

    <fieldset v-if="config.categories" class="ecm-filters ecm-filters-categories">

        <legend> {{ $t("tagFiltersLegend") }} </legend>
        
        <div v-if="! categories" class="ecm-loader" style="margin-top:5px;"></div>

        <ul v-if="categories" class="ecm-filters-list">

            <li class="ecm-form-group-cb ecm-toggle-all-group">
                <label for="toggleAllCategories"> {{ $t("toggleAll") }} </label>
                <input
                    type="checkbox"
                    id="toggleAllCategories"
                    @change="toggleAll($event)"
                    class="ecm-checkbox" 
                    :checked="config.categories.length == checkedCategories.length" />
            </li>

            <li
                v-for="category in config.categories"
                :key="'cat-' + category.id"
                class="ecm-form-group-cb">
                <label v-bind:for="'cat-' + category.id">
                    <!-- svg-injector 
                        v-if="getCategoryIcon(category.id)" 
                        :src="getCategoryIcon(category.id)"
                        class="ecm-category-icon">
                    </svg-injector -->
                    <img 
                        v-if="hasCategoryIcon(category.id)" 
                        :src="getCategoryIcon(category.id)"
                        :alt="getCategoryName(category.id)"
                        class="ecm-category-icon" />
                    {{ getCategoryName(category.id) }}
                </label>
                <input
                    v-model="checkedCategories"
                    :id="'cat-' + category.id"
                    :value="category.id"
                    type="checkbox"
                    class="ecm-checkbox" />
            </li>

        </ul>

    </fieldset>

</template>

<script>
import { eventBus } from '../main.js';
import { store } from '../store/store';
import axios from 'axios';

export default {
    name: 'Categories',
    components: {
        
    },
    props: {
        
    },
    store: store,
    computed: {
        config() {
            return store.state.config;
        },
        checkedCategories: {
            set(val) {
                this.$store.commit('setCheckedCategories', val);
            },
            get() { 
                return this.$store.state.checkedCategories;
            }
        },
        themeColor() {
            if (store.state.config && store.state.config.themeColor) {
                return store.state.config.themeColor;
            }
            return null;
        },
        themeTextColor() {
            if (store.state.config && store.state.config.themeColor) {
                return this.$setThemeTextColor(store.state.config.themeColor);
            }
            return null;
        },
        themeHoverColor() {
            if (store.state.config && store.state.config.themeColor) {
                return this.$setThemeHoverColor(store.state.config.themeColor);
            }
            return null;
        }
    },
    watch: {
        checkedCategories(newVal, oldVal) {
            // Reload data if new categories checked
            if (newVal.length > oldVal.length) {
                eventBus.$emit('reloadMarkersAndRoutes');
            }
        }
    },
    data() {
        return {
            categories: null
        }
    },
    created() {
        // Event bus load categories handler
        eventBus.$on('loadCategories', this.loadCategories);

        this.loadCategories();
    },
    methods: {
        toggleAll(e) {
            if (e.target.checked) {
                // Select all categories
                let allCatIds = this.config.categories.map(category => category.id);
                this.$store.commit('setCheckedCategories', allCatIds);
            } else {
                // Deselect all categories
                this.$store.commit('setCheckedCategories', []);
            }
        },
        /**
         * @param   {number}    catId
         * @returns {string}
         */
        getCategoryName(catId) {
            let cat = this.categories.find(item => item.id == catId && item.lan == store.state.lan);
            if (cat) {
                return cat.name;
            }
            // Category not found in current language, get English
            cat = this.categories.find(item => item.id == catId && item.lan == 'en');
            if (cat) {
                return cat.name;
            }
            // Category not found in English, get it in any language
            cat = this.categories.find(item => item.id == catId);
            if (cat) {
                return cat.name;
            }
            // Category not found in any language (which shouldn't really happen)
            return null;
        },
        /**
         * @param   {number}    catId
         * @returns {string}
         */
        hasCategoryIcon(catId) {
            let cat = this.categories.find(item => item.id == catId);
            if (cat && cat.icon) {
                return true;
            }
            return false;
        },
        /**
         * @param   {number}    catId
         * @returns {string}
         */
        getCategoryIcon(catId) {
            let cat = this.categories.find(item => item.id == catId);
            if (cat) {
                let iconUrl = cat.icon;
                if (this.themeColor && this.themeTextColor) {
                    // Theme colors are set, get icon url via global method to set the color params
                    iconUrl = this.$setIconUrl(iconUrl, this.themeColor, this.themeTextColor);
                }
                if (iconUrl.indexOf('?') === -1) {
                    return iconUrl + '?v=2021-09-29';
                }
                return iconUrl + '&v=2021-09-29';
            }
            return null;
        },
        /**
         * Loads map categories details from the DB in all available languages.
         */
        loadCategories() {
            let allCatIds = this.config.categories.map(category => category.id);
            eventBus.$emit('addStatus', 'Loading categories');
            axios.get(process.env.VUE_APP_LOCATIONS_API_PATH + '/categories', {
                params: {
                    categoryIds: allCatIds.join()
                }
            })
            .then((response) => {
                //console.log(response);
                this.categories = response.data;
                eventBus.$emit('removeStatus', 'Loading categories');
            })
            .catch(function(error) {
                console.error('Error loading categories: ' + error);
            });
        }
    }
}

</script>

<style scoped>

</style>
